import { render } from "./Controller.vue?vue&type=template&id=42bc2b7a"
import script from "./Controller.vue?vue&type=script&lang=js"
export * from "./Controller.vue?vue&type=script&lang=js"

import exportComponent from "/Users/williamsandstrom/repos/web/ytopi/ytopi-configurator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__